import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GetnetService {
  private listenerRetornoGetnet: any;

  abrirLightbox(url: string) {
    if(!url) return;

    if(this.listenerRetornoGetnet)
      window.removeEventListener('message', this.listenerRetornoGetnet);

    const existente = document.getElementById('getnet-lightbox-promokit');
    if(existente)
      existente.remove();

    const overlay = document.createElement('div');
    overlay.id = 'getnet-lightbox-promokit';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.right = '0';
    overlay.style.bottom = '0';
    overlay.style.left = '0';
    overlay.style.zIndex = '99999';
    overlay.style.background = 'rgba(0,0,0,.55)';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.padding = '12px';

    const container = document.createElement('div');
    container.style.position = 'relative';
    container.style.width = 'min(100%, 520px)';
    container.style.height = 'min(100%, 760px)';
    container.style.background = '#fff';
    container.style.boxShadow = '0 12px 40px rgba(0,0,0,.3)';

    const fechar = document.createElement('button');
    fechar.type = 'button';
    fechar.innerText = 'x';
    fechar.setAttribute('aria-label', 'Fechar checkout Getnet');
    fechar.style.position = 'absolute';
    fechar.style.top = '8px';
    fechar.style.right = '8px';
    fechar.style.zIndex = '1';
    fechar.style.width = '32px';
    fechar.style.height = '32px';
    fechar.style.border = '0';
    fechar.style.borderRadius = '16px';
    fechar.style.background = '#111';
    fechar.style.color = '#fff';
    fechar.style.cursor = 'pointer';

    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = '0';
    iframe.setAttribute('allow', 'payment *');

    const fecharLightbox = () => {
      if(this.listenerRetornoGetnet)
        window.removeEventListener('message', this.listenerRetornoGetnet);

      this.listenerRetornoGetnet = null;
      overlay.remove();
    };

    const receberMensagemRetornoGetnet = (event: MessageEvent) => {
      const data: any = event.data;
      const mensagemObjeto = data && data.origem === 'promokit-getnet' && data.acao === 'fechar-lightbox';
      const mensagemTexto = data === 'getnet-lightbox-close';

      if(mensagemObjeto || mensagemTexto)
        fecharLightbox();
    };

    fechar.onclick = () => fecharLightbox();
    this.listenerRetornoGetnet = receberMensagemRetornoGetnet;
    window.addEventListener('message', this.listenerRetornoGetnet, false);

    container.appendChild(fechar);
    container.appendChild(iframe);
    overlay.appendChild(container);
    document.body.appendChild(overlay);
  }
}
